import { render, staticRenderFns } from "./Bidder.vue?vue&type=template&id=d3ddb30c&scoped=true&"
import script from "./Bidder.vue?vue&type=script&lang=js&"
export * from "./Bidder.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Bidder.vue?vue&type=style&index=0&id=d3ddb30c&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d3ddb30c",
  null
  ,true
)

export default component.exports